// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"4fff8adb","45":"a2892628","297":"32afd9fd","330":"3e932d45","551":"dcaa77b1","665":"ed6be059","733":"3c0bc2be","753":"5403f61a","984":"2c6bc27a"}[chunkId] + ".chunk.js";
};